import { Component, Input, OnInit } from '@angular/core';

import { ConfigService } from '@app/core/config.service';
import { LinksService } from '@app/core/links.service';

import { FooterAnalyticsService } from './footer-analytics.service';

@Component({
  selector: 'om-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() homePage: boolean;
  currentYear: number;
  medicalTermsOfServiceLink = this.linksService.MEDICAL_TERMS_OF_SERVICE;

  constructor(
    public configService: ConfigService,
    public footerAnalyticsService: FooterAnalyticsService,
    private linksService: LinksService,
  ) {}

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.footerAnalyticsService.setFlowAndModule(this.homePage);
  }

  trackFooterLink(linkClicked: string): Function {
    return this.footerAnalyticsService.trackFooterLink.bind(this.footerAnalyticsService, linkClicked);
  }
}
